module.exports = __webpack_public_path__ + "static/img/20014 (2).e82e0c2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20014 (2).webp
// module id = mGkE
// module chunks = 14